import React from 'react';
import {useRouter} from 'next/router';
import {getLocaleContent} from '@helper/locale-content.js';
/**
 * Component hiển thị tất cả validation errors của form
 * @param {Object} props
 * @param {Object} props.errors - Object chứa tất cả errors
 * @param {string} props.className - CSS class name
 * @param {Object} props.style - Inline styles
 * @param {boolean} props.show - Có hiển thị errors hay không
 */
const FormErrors = ({errors = {}, className = '', style = {}, show = true}) => {
    const {locale} = useRouter();
    // Không hiển thị nếu không có errors
    if (!errors || Object.keys(errors).length === 0 || !show) return null;

    const errorList = Object.entries(errors).filter(([key, value]) => value);

    if (errorList.length === 0) return null;

    const containerStyle = {
        background: '#fff2f0',
        border: '1px solid #ffccc7',
        borderRadius: '6px',
        padding: '12px',
        marginBottom: '16px',
        ...style,
    };

    const titleStyle = {
        color: '#ff4d4f',
        fontSize: '14px',
        fontWeight: '500',
        marginBottom: '8px',
        display: 'block',
    };

    const listStyle = {
        margin: 0,
        padding: 0,
        listStyle: 'none',
    };

    const itemStyle = {
        color: '#ff4d4f',
        fontSize: '12px',
        marginBottom: '4px',
        paddingLeft: '12px',
        position: 'relative',
    };

    const bulletStyle = {
        position: 'absolute',
        left: 0,
        top: '6px',
        width: '4px',
        height: '4px',
        backgroundColor: '#ff4d4f',
        borderRadius: '50%',
    };

    return (
        <div className={`form-errors ${className}`} style={containerStyle} role="alert">
            <span style={titleStyle}>
                {getLocaleContent(locale, 'page.booking-form.validation.full-name-required') + ':'}
            </span>
            <ul style={listStyle}>
                {errorList.map(([field, error]) => (
                    <li key={field} style={itemStyle}>
                        <span style={bulletStyle}></span>
                        {error}
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default FormErrors;
